import { SupplyState } from "@/api/model"

export const activeSwitchStates = new Set<SupplyState>([
  SupplyState.preOnboarding,
  SupplyState.onboarding,
  SupplyState.onboardingPartiallyRejected,
  SupplyState.onboardingPartiallyObjected,
  SupplyState.onboardingPartiallyCancelled,
  SupplyState.onboardedRecently,
  SupplyState.onboardingAdditionalMeterpoint,
  SupplyState.futureMoveIn,
])
